"use strict";
/*
 * HSScrollspy
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSScrollspy = /** @class */ (function (_super) {
    __extends(HSScrollspy, _super);
    function HSScrollspy(el, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, el, options) || this;
        _this.activeSection = null;
        _this.contentId = _this.el.getAttribute('data-hs-scrollspy');
        _this.content = document.querySelector(_this.contentId);
        _this.links = _this.el.querySelectorAll('[href]');
        _this.sections = [];
        _this.scrollableId = _this.el.getAttribute('data-hs-scrollspy-scrollable-parent');
        _this.scrollable = _this.scrollableId
            ? document.querySelector(_this.scrollableId)
            : document;
        _this.init();
        return _this;
    }
    HSScrollspy.prototype.init = function () {
        var _this = this;
        this.createCollection(window.$hsScrollspyCollection, this);
        this.links.forEach(function (el) {
            _this.sections.push(_this.scrollable.querySelector(el.getAttribute('href')));
        });
        Array.from(this.sections).forEach(function (section) {
            if (!section.getAttribute('id'))
                return false;
            _this.scrollable.addEventListener('scroll', function (evt) {
                return _this.update(evt, section);
            });
        });
        this.links.forEach(function (el) {
            el.addEventListener('click', function (evt) {
                evt.preventDefault();
                if (el.getAttribute('href') === 'javascript:;')
                    return false;
                _this.scrollTo(el);
            });
        });
    };
    HSScrollspy.prototype.update = function (evt, section) {
        var globalOffset = parseInt((0, utils_1.getClassProperty)(this.el, '--scrollspy-offset', '0'));
        var userOffset = parseInt((0, utils_1.getClassProperty)(section, '--scrollspy-offset')) || globalOffset;
        var scrollableParentOffset = evt.target === document
            ? 0
            : parseInt(String(evt.target.getBoundingClientRect().top));
        var topOffset = parseInt(String(section.getBoundingClientRect().top)) -
            userOffset -
            scrollableParentOffset;
        var height = section.offsetHeight;
        if (topOffset <= 0 && topOffset + height > 0) {
            if (this.activeSection === section)
                return false;
            this.links.forEach(function (el) {
                el.classList.remove('active');
            });
            var current = this.el.querySelector("[href=\"#".concat(section.getAttribute('id'), "\"]"));
            if (current) {
                current.classList.add('active');
                var group = current.closest('[data-hs-scrollspy-group]');
                if (group) {
                    var parentLink = group.querySelector('[href]');
                    if (parentLink)
                        parentLink.classList.add('active');
                }
            }
            this.activeSection = section;
        }
    };
    HSScrollspy.prototype.scrollTo = function (link) {
        var targetId = link.getAttribute('href');
        var target = document.querySelector(targetId);
        var globalOffset = parseInt((0, utils_1.getClassProperty)(this.el, '--scrollspy-offset', '0'));
        var userOffset = parseInt((0, utils_1.getClassProperty)(target, '--scrollspy-offset')) || globalOffset;
        var scrollableParentOffset = this.scrollable === document
            ? 0
            : this.scrollable.offsetTop;
        var topOffset = target.offsetTop - userOffset - scrollableParentOffset;
        var view = this.scrollable === document ? window : this.scrollable;
        var scrollFn = function () {
            window.history.replaceState(null, null, link.getAttribute('href'));
            if ('scrollTo' in view) {
                view.scrollTo({
                    top: topOffset,
                    left: 0,
                    behavior: 'smooth',
                });
            }
        };
        var beforeScroll = this.fireEvent('beforeScroll', this.el);
        (0, utils_1.dispatch)('beforeScroll.hs.scrollspy', this.el, this.el);
        if (beforeScroll instanceof Promise)
            beforeScroll.then(function () { return scrollFn(); });
        else
            scrollFn();
    };
    // Static methods
    HSScrollspy.getInstance = function (target, isInstance) {
        if (isInstance === void 0) { isInstance = false; }
        var elInCollection = window.$hsScrollspyCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element.el
            : null;
    };
    HSScrollspy.autoInit = function () {
        if (!window.$hsScrollspyCollection)
            window.$hsScrollspyCollection = [];
        document
            .querySelectorAll('[data-hs-scrollspy]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsScrollspyCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSScrollspy(el);
        });
    };
    return HSScrollspy;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSScrollspy.autoInit();
    // Uncomment for debug
    // console.log('Scrollspy collection:', window.$hsScrollspyCollection);
});
if (typeof window !== 'undefined') {
    window.HSScrollspy = HSScrollspy;
}
exports.default = HSScrollspy;
